var render = function render(){
  var _vm$selectedData$year;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.selectedData ? _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "fleet-image"
  }, [_c('img', {
    staticClass: "w-100 h-100 object-fit-cover",
    attrs: {
      "src": _vm.getValidFleetImage(),
      "alt": "Fleet Image"
    }
  })])]), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "pl-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('img', {
    staticClass: "icon-badge mr-2",
    attrs: {
      "src": require('../Components/Icons/icon-fleet.svg')
    }
  }), _c('div', [_c('h5', {
    staticClass: "mb-0 text-primary font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.selectedData.vehicle_name) + " "), _c('span', {
    staticClass: "ml-2 text-danger"
  }, [_vm._v("●")])]), _c('strong', {
    staticClass: "text-black mb-2"
  }, [_vm._v(" " + _vm._s(_vm.selectedData.company_name) + " ")])])]), _c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Fleet Type")]), _c('td', {
    staticClass: "font-semibold text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.selectedData.vehicle_type_name) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Call Sign")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.selectedData.vehicle_code))])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Flag")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.selectedData.vehicle_flag))])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Year & Building")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(" " + _vm._s((_vm$selectedData$year = _vm.selectedData.year_build_country) !== null && _vm$selectedData$year !== void 0 ? _vm$selectedData$year : '-') + " ")])])])])])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }